import script from "./ShopInventory.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopInventory.vue?vue&type=script&setup=true&lang=js"

import "./ShopInventory.vue?vue&type=style&index=0&id=bbbd69fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbbd69fc"]])

export default __exports__